import styled from "styled-components";

import { SWReactCountryIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const StyledTooltipContent = styled(Stack)`
    color: ${colorsPalettes.carbon[500]};
    max-width: 250px;
    flex: 0 1 auto;
    gap: 4px;
`;

export const StyledCountryIcon = styled(SWReactCountryIcons)`
    width: 14px;
    height: 14px;
`;

export const StyledDetailedResultItem = styled(Flex)`
    width: 100%;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
`;
